import getDistanceBetweenTwoLocations from '../getDistanceBetweenTwoLocations';

const getDistanceToTarget = (target, location) => {
  const locationPosition = {
    latitude: location.latitude,
    longitude: location.longitude,
  };

  return getDistanceBetweenTwoLocations(target, locationPosition);
};

const setLocationsDistanceToTarget = (locations, targetLocation) => {
  return locations.reduce((updatedLocations, location) => {
    location.distanceInKm = getDistanceToTarget(targetLocation, location);
    return [...updatedLocations, location];
  }, []);
};

const normalizeDistance = (currentLocationDistance, maxDistance) => {
  if (maxDistance <= 0 || currentLocationDistance <= 0) return 0;
  const score = Number(1 - currentLocationDistance / maxDistance);
  return score > 0 ? score.toFixed(4) : 0;
};

const normalizeTimeslots = (currentLocationSlots, maxSlotsNo) => {
  if (maxSlotsNo <= 0 || currentLocationSlots <= 0) return 0;
  const score = Number(currentLocationSlots / maxSlotsNo);
  return score > 0 ? score.toFixed(4) : 0;
};

const calculateDistanceAndTimeslotsScore = (locations, distanceWeight) => {
  const maxDistanceToTarget = locations.reduce(
    (maxDistance, location) => Math.max(maxDistance, location.distanceInKm),
    locations[0].distanceInKm,
  );
  const maxAvailableSlotsInALocation = locations.reduce(
    (maxSlots, location) => Math.max(maxSlots, location.service.noOfAvailableSlots),
    locations[0].service.noOfAvailableSlots,
  );

  return locations.reduce((locationsWithScore, location) => {
    const timeSlotsScore = Number(
      normalizeTimeslots(location.service.noOfAvailableSlots, maxAvailableSlotsInALocation),
    );
    location.timeSlotsScore = timeSlotsScore;

    if (timeSlotsScore === 0) {
      location.sortingScore = 0;
    } else {
      const distanceScore = normalizeDistance(location.distanceInKm, maxDistanceToTarget);
      location.sortingScore = Number(distanceWeight * distanceScore + (1 - distanceWeight) * timeSlotsScore).toFixed(4);
    }

    return [...locationsWithScore, location];
  }, []);
};

const sortAndCalculateLocationsBySortingScore = (locations, distanceWeight, shouldApplyAlgorithm = true) => {
  if (shouldApplyAlgorithm) {
    const locationsWithScore = calculateDistanceAndTimeslotsScore(locations, distanceWeight);
    return locationsWithScore.sort((a, b) => b.sortingScore - a.sortingScore);
  } else {
    return locations.sort((a, b) => a.distanceInKm - b.distanceInKm);
  }
};

const getClosestLocationsByDistanceAndTimeSlots = (
  locations,
  targetLocation,
  distanceWeight = 0.6,
  distanceInKm = 20,
) => {
  const locationsWithDistance = setLocationsDistanceToTarget(locations, targetLocation);

  // show all locations within provided distance from the searched location
  const locationsWithinClosestDistance = locationsWithDistance.filter(
    location => location.distanceInKm <= distanceInKm,
  );

  // if we have locations within the respective radius, we should apply the sorting algo on them
  // and if we don't, we will take the top 3 closest locations to the given place (with no sorting algo)
  const sortedLocations =
    locationsWithinClosestDistance.length === 0
      ? sortAndCalculateLocationsBySortingScore(locationsWithDistance, distanceWeight, false).slice(0, 3) // if there is no location within provided, show the closest 3 locations
      : sortAndCalculateLocationsBySortingScore(locationsWithinClosestDistance, distanceWeight);

  // todo: remove the console log in the next iteration
  console.log('-----------------------');
  sortedLocations.forEach(location => {
    console.log(
      location.code,
      '-',
      location.marketingName || location.heading,
      '-',
      location.service.noOfAvailableSlots + ' slots',
      '-',
      location.timeSlotsScore,
      '-',
      location.distanceInKm + ' km',
      '-',
      location.sortingScore,
    );
  });

  return sortedLocations;
};

export { getClosestLocationsByDistanceAndTimeSlots };
